__turbopack_context__.v({
  "content": "tabs-module__cY31eW__content",
  "indicator": "tabs-module__cY31eW__indicator",
  "list": "tabs-module__cY31eW__list",
  "list_lg": "tabs-module__cY31eW__list_lg",
  "list_md": "tabs-module__cY31eW__list_md",
  "list_sm": "tabs-module__cY31eW__list_sm",
  "trigger": "tabs-module__cY31eW__trigger",
  "trigger_lg": "tabs-module__cY31eW__trigger_lg",
  "trigger_md": "tabs-module__cY31eW__trigger_md",
  "trigger_sm": "tabs-module__cY31eW__trigger_sm",
});
